import React, { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Row } from 'antd';

import { DescriptionModal } from '../../components/DescriptionModal';
import { useUpdateImage } from '../../hooks/useUpdateImage';
import { useDeleteImage } from '../../hooks/useDeleteImage';
import { Paragraph, Title } from '@/components/Typography';
import { DeleteModal } from '../../components/DeleteModal';
import { NextButton, PreviousButton } from '../../styles';
import { useRosaContext } from '../../context';
import { Content } from './styles';
import { Images } from './Images';

const { useFormInstance } = Form;

export function UploadImage() {
	const form = useFormInstance();
	const { organization_id, company_id, report_id, onPreviousStep, onNextStep } = useRosaContext();

	const { mutateAsync: deleteImage } = useDeleteImage();
	const { mutateAsync: updateImage } = useUpdateImage();

	const [selectedImage, setSelectedImage] = useState<any>({});
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
	const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);

	function handleToggleDeleteModal(): void {
		setIsDeleteModalOpen(!isDeleteModalOpen);
	}

	function handleToggleDetailsModal(): void {
		setIsDetailsModalOpen(!isDetailsModalOpen);
	}

	function handleDelete(image: any): void {
		setSelectedImage(image);
		handleToggleDeleteModal();
	}

	function handleDetails(image: any): void {
		setSelectedImage(image);
		handleToggleDetailsModal();
	}

	async function handleRemove(): Promise<void> {
		await deleteImage({ organization_id, company_id, image_id: selectedImage.uid, report_id });
		handleToggleDeleteModal();
	}

	async function handleSaveDescription(): Promise<void> {
		const description = await form.getFieldValue([selectedImage.uid, 'image_description']);

		const payload = {
			company_id,
			description,
			organization_id,
			report_id,
			image_id: selectedImage.uid
		};

		await updateImage(payload);
		handleToggleDetailsModal();
	}

	return (
		<Row gutter={[0, 40]}>
			<Col span={24}>
				<Row align="middle">
					<Col xs={12}>
						<Title level={4}>{I18n.get('Upload image')}</Title>
					</Col>
					<Col xs={24} style={{ marginBottom: '20px' }}>
						<Paragraph>
							{I18n.get('Upload images of the activity being evaluated')}
						</Paragraph>
					</Col>
				</Row>
			</Col>
			<Content span={24}>
				<Row gutter={[0, 20]}>
					<Col span={24}>
						<Title level={5}>{I18n.get('Image')}</Title>
					</Col>
					<Col>
						<Images onDetails={handleDetails} onDelete={handleDelete} />
					</Col>
				</Row>
			</Content>
			<Col span={24}>
				<Row justify="center" gutter={[30, 0]}>
					<Col>
						<PreviousButton type="ghost" onClick={onPreviousStep}>
							{I18n.get('Back')}
						</PreviousButton>
					</Col>
					<Col>
						<NextButton type="primary" onClick={onNextStep}>
							{I18n.get('Next')}
						</NextButton>
					</Col>
				</Row>
			</Col>
			<DescriptionModal
				image={selectedImage}
				open={isDetailsModalOpen}
				onConfirm={handleSaveDescription}
				onCancel={handleToggleDetailsModal}
			/>
			<DeleteModal
				open={isDeleteModalOpen}
				onConfirm={handleRemove}
				onCancel={handleToggleDeleteModal}
				message={I18n.get('Do you really want to delete this image?')}
			/>
		</Row>
	);
}
